import { render, staticRenderFns } from "./DisplayTitle.vue?vue&type=template&id=3734a754&scoped=true&"
import script from "./DisplayTitle.vue?vue&type=script&lang=js&"
export * from "./DisplayTitle.vue?vue&type=script&lang=js&"
import style0 from "./DisplayTitle.vue?vue&type=style&index=0&id=3734a754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734a754",
  null
  
)

export default component.exports